import { addNavMenuItem, addActionBarItem } from "@vendure/admin-ui/core";
import { allow } from "../common/ui/utils";
import { CustomPermissions } from "../common/ui/ui-types";

export default [
    addNavMenuItem({
        id: 'store-domains',
        label: 'Domains',
        icon: 'world',
        routerLink: ['/store-settings', 'domains'],
        requiresPermission: allow(CustomPermissions.ReadCustomDomain),
    },
    'store-settings',
    'store-pages')
];
